import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/svg/clock.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "times-up-content" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, "Click on the button to display the correct answer.")
], -1)

import { ref } from 'vue'
import Modal from '../Modal.vue'


export default /*#__PURE__*/_defineComponent({
  emits: ['onShowAnswers'],
  setup(__props, { expose, emit }) {



const timesUpModal = ref<InstanceType<typeof Modal> | null>(null)

async function show() {
  timesUpModal.value?.show()
}

function onShowAnswers() {
  emit('onShowAnswers')
}

expose({
  show,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "timesUpModal",
    ref: timesUpModal,
    class: "modal-times-up",
    title: "Time's up",
    "validate-btn-text": "Show the correct answer(s)",
    onOnCancelClick: onShowAnswers
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 512))
}
}

})